var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.crumbs),function(crumb){return _c('li',{key:crumb.path},[_c('router-link',{attrs:{"to":_vm.url(crumb.path)},domProps:{"textContent":_vm._s(crumb.basename)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }